export default function safeExec(fn) {
  if (fn && typeof fn === 'function') fn();
}
